import React, { useEffect, useState, useContext } from "react";

import LoadingInfynito from "../Shared/LoadingInfynito";
import StaticDeck from "../Arrangement/StaticDeck";
import Mood from "../Interiors/Mood";

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";

import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';
import FooterFerrettiInfynito from "../Home/FooterFerrettiInfynito";

import RequestForm from "../Form/RequestForm";




export const Summary = (props) => {
    const localizationCtx = useContext(LocalizationContext);

    const [isLoading, setIsLoading] = useState(true);
    const [customization, setCustomization] = useState();
    const customizationCtx = useContext(CustomizationContext);

    const [crmData, setCrmData] = useState(null);


    const loadConfigurationAndData = async () => {
        setIsLoading(true);
        const response = await fetch("/api/customization/get/" + customizationCtx.customizationData.idCustomization + "/" + customizationCtx.customizationData.language);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                setCustomization(data);
            } else {
                props.feedbackCallback("error", "Error loading configuration", true);
            }

        } else {
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }

        const responseCat = await fetch("/api/request/getcatalogue");

        if (responseCat.ok) {
            const data = await responseCat.json();
            if (data) {
                setCrmData(data);
            } else {
                props.feedbackCallback("error", "Error loading external data", true);
            }

        } else {
            const error = await responseCat.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }

        setIsLoading(false);
    }

    useEffect(() => {
        loadConfigurationAndData();
        window.scrollTo(0, 0);
    }, []);

    const handleBackClick = () => {
        props.updateStepCallBack(1);
    }

    return (
        <>
            {isLoading &&
                <div className="py-5 bkg-white">
                    <LoadingInfynito message={localizationCtx.localizationData.loadingWait} />
                </div>
            }
            {!isLoading &&
                <>
                <div className="content-wrap bkg-deep-ocean">
                    <div className="container-fluid bkg-sand d-block d-sm-none">
                        <div className="row py-5">
                            <div className="col-12 py-5 text-center">
                                <p className="text-infynito-section text-center">{localizationCtx.localizationData.landscapeMode2}</p>
                                <p className="pt-5"><ScreenRotationIcon /></p>
                            </div>
                        </div>
                    </div>

                    <div className="d-none d-sm-block bkg-white">


                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    {customization.modelDecks.map((myDeck, i) => (
                                        <StaticDeck key={i} deck={myDeck} viewMode="summary" feedbackCallback={props.feedbackCallback} />
                                    ))}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 py-5">
                                    <Mood viewMode="summary" />
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row justify-content-center pb-5">
                                <div className="col-12 text-end">
                                    <a className="flat-gray-button text-uppercase button-infynito-notactive mt-5" onClick={handleBackClick}>{localizationCtx.localizationData.buttonBack}</a>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid bkg-light-gray">
                            <div className="row py-5">
                                <div className="col-12">
                                    <p className="infynito-section-subtitle2 text-center py-2">{localizationCtx.localizationData.contactTitle}</p>
                                    <p className="text-infynito-section2 text-center">{localizationCtx.localizationData.contactSubTitle}</p>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid bkg-light-gray">
                            <RequestForm modelCode={props.modelCode} withCustomization={true} feedbackCallback={props.feedbackCallback} updateStepCallBack={props.updateStepCallBack} />
                        </div>

                    </div>
                </div>
                <FooterFerrettiInfynito cultureCode={props.cultureCode} />
                </>
            }
        </>
    );
};

export default Summary;
